/**
 * Text TS class for the Text TCA-CE
 */
export class Text
{

}

// Porperty Slider Cover-effect

import Swiper from 'swiper';
import { Navigation, Pagination, EffectCoverflow } from 'swiper/modules';
Swiper.use([Navigation, Pagination, EffectCoverflow]);

let sw: Swiper | null = null;
let sw2: Swiper | null = null;
let isMobile = window.innerWidth < 768;

function updateSwiper (selector: string): void {

  if( sw ) {
    sw.destroy(true, true);
  }

  // optional safety
  if (!document.querySelector(selector)) return;

  if( isMobile ) {
    sw = new Swiper(selector, {
      slidesPerView: 1,              
      centeredSlides: false,
      spaceBetween: 30,
      observer: true,
      observeParents: true,
      updateOnWindowResize: true,
      loop: true,
      pagination: { el: selector + ' .swiper-pagination', clickable: true },
      navigation: {
        nextEl: selector +  ' .swiper-button-next',
        prevEl: selector +  ' .swiper-button-prev',
      },
      initialSlide: 1,                 
    });    
  }
  else {
    sw = new Swiper(selector, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      observer: true,
      observeParents: true,
      updateOnWindowResize: true,
      loop: true,
      effect: 'coverflow',
      
      coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 300,
          modifier: 3,
          slideShadows: false 
        },
      centeredSlides: true,
      centeredSlidesBounds: true,
      pagination: { el: selector + ' .swiper-pagination', clickable: true },
      navigation: {
        nextEl: selector +  ' .swiper-button-next',
        prevEl: selector +  ' .swiper-button-prev',
      },
      initialSlide: 1,     
       on: {
        init() {
          setMaxHeight(selector);
        },
        slideChange() {
          setMaxHeight(selector);
        }
      }
    });    
  }
}


document.addEventListener('LatestOffersLoaded', () => {
  //console.log("Event received!");
  updateSwiper('.property-slider-latest');
  setMaxHeight('.property-slider-latest');
});

updateSwiper('.estate-slider-latest');
window.addEventListener('resize', () => {
  let isMobileNew = window.innerWidth < 768;

  if( isMobileNew != isMobile ) {
    isMobile = isMobileNew;
    updateSwiper('.property-slider-latest');
    updateSwiper('.estate-slider-latest');
  }

  setMaxHeight('.property-slider-latest');
  setMaxHeight('.estate-slider-latest');
  
});

function setMaxHeight(selector: string): void {
  const propItems = document.querySelectorAll<HTMLElement>(
    `${selector} .prop-item`
  );

  if (!propItems.length) return;

  // Reset
  propItems.forEach((el) => (el.style.height = 'auto'));

  // Measure
  let max = 0;
  propItems.forEach((el) => {
    const h = el.offsetHeight;
    if (h > max) max = h;
  });

  // Apply
  propItems.forEach((el) => (el.style.height = `${max}px`));
}

function initSwiper(selector: string): void {

  new Swiper(selector, {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 30,
    centeredSlides: false,
    updateOnWindowResize: true,
    observer: true,
    observeParents: true,
    pagination: { el: `${selector} .swiper-pagination`, clickable: true },
    navigation: {
      nextEl: `${selector} .swiper-button-next`,
      prevEl: `${selector} .swiper-button-prev`,
    },
  });
}


initSwiper('.estate-slider');



//Text-Navigation

function initTextNavigation(): void {
  const sections = document.querySelectorAll<HTMLElement>('.text-navigation');

  const createId = (text: string, index: number): string => {
    return (
      text
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w\-äöüß]/g, '') + `-${index}`
    );
  };

  sections.forEach((section) => {
    const navigation = section.querySelector<HTMLElement>('nav');
    const headings = section.querySelectorAll<HTMLHeadingElement>(
      '.bodytext h2, .bodytext h3'
    );

    if (!navigation || headings.length === 0) {
      return;
    }

    navigation.innerHTML = '';

    headings.forEach((heading, index) => {
      const text = heading.textContent?.trim();

      if (!text) {
        return;
      }

      const id = heading.id || createId(text, index);
      heading.id = id;

      const link = document.createElement('a');

      link.href = `#${id}`;
      link.textContent = text;
      link.classList.add('text-navigation-link');

      if (heading.tagName === 'H3') {
        link.classList.add('text-navigation-link--sub');
      }

      link.addEventListener('click', () => {
        navigation
          .querySelectorAll('.text-navigation-link')
          .forEach((navLink) => navLink.classList.remove('active'));
       
        link.classList.add('active');

      });

      navigation.appendChild(link);
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initTextNavigation();
});



